import { createContext, ReactNode, useReducer } from 'react';
import {
  AdvancedSearchReducer,
  IAdvancedSearchState,
} from 'reducer/MedicalReferrals/AdvancedSearchReducer';

interface IAdvancedSearchContext {
  advancedSearch: IAdvancedSearchState;
  dispatchAdvancedSearch: Function;
}

export const AdvancedSearchContext = createContext<IAdvancedSearchContext>({
  advancedSearch: {
    requestState: null,
    requestNumber: null,
    providerName: null,
    requestValidation: {
      presentValidated: false,
      pastValidated: false,
      futureValidated: false,
    },
    dateRange: {
      start: null,
      end: null,
      isYear: false,
    },
    activeSearch: {
      text: false,
      advanced: false,
    },
    supplierNames: [],
    dateMinMaxRange: {
      min: new Date(),
      max: new Date(),
    },
    requestNumberList: [],
  },
  dispatchAdvancedSearch: () => {},
});

type Props = { children: ReactNode };

export const AdvancedSearchContextProvider = ({ children }: Props) => {
  const [advancedSearch, dispatchAdvancedSearch]: [
    IAdvancedSearchState,
    Function
  ] = useReducer(AdvancedSearchReducer, {
    requestState: null,
    requestNumber: null,
    providerName: null,
    requestValidation: {
      presentValidated: false,
      pastValidated: false,
      futureValidated: false,
    },
    dateRange: {
      start: null,
      end: null,
      isYear: false,
    },
    activeSearch: {
      text: false,
      advanced: false,
    },
    supplierNames: [],
    dateMinMaxRange: {
      min: new Date(),
      max: new Date(),
    },
    requestNumberList: [],
  });

  return (
    <AdvancedSearchContext.Provider
      value={{
        advancedSearch,
        dispatchAdvancedSearch,
      }}
    >
      {children}
    </AdvancedSearchContext.Provider>
  );
};
